import React, { Component } from "react";
import PropTypes from "prop-types";
import { reduxForm, formValueSelector, change } from "redux-form";
import { connect } from "react-redux";
import compose from "recompose/compose";
import { Toolbar } from "admin-on-rest";
import { showNotification as showNotificationAction } from "admin-on-rest";

import getDefaultValues from "../components/form/getDefaultValues";
import { ValuesForm } from "../components/form/ValuesForm";
import { DivFormContainer } from "./styled";

import {
  BanksField,
  CategoryField,
  DetailsField,
  SocialField,
} from "./MarketerField";

import { RestApiShortUrl } from "../restClient";

class MarketerForm extends Component {
  handleSubmitWithRedirect = (redirect = this.props.redirect) =>
    this.props.handleSubmit((values) => {
      // this.props.save(values, redirect);
      this.getSlug(values, redirect);
    });

  getSlug = (values, redirect) => {
    RestApiShortUrl(values.nickname)
      .then((response) => {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.json();
      })
      .then((data) => {
        if (!data.exists) {
          this.props.save(values, redirect);
        } else {
          this.props.showNotification("The Slug already have", "warning");
        }
      })
      .catch((e) => {
        this.props.showNotification("Please try again", "warning");
        console.error(e);
      });
  };
  render() {
    const {
      children,
      invalid,
      record,
      resource,
      basePath,
      submitOnEnter,
      toolbar,
      translate,
      updateField,
    } = this.props;
    return (
      <div>
        <form className="simple-form">
          <DivFormContainer>
            {DetailsField(
              children,
              record,
              resource,
              basePath,
              translate,
              updateField
            )}
            {BanksField(children, record, resource, basePath, translate)}
            {SocialField(
              children,
              record,
              resource,
              basePath,
              translate,
              this.props
            )}
            {CategoryField(children, record, resource, basePath, translate)}
          </DivFormContainer>
          {toolbar &&
            React.cloneElement(toolbar, {
              handleSubmitWithRedirect: this.handleSubmitWithRedirect,
              invalid,
              submitOnEnter,
            })}
        </form>
        <ValuesForm isDebug={false} formName={"record-form"} />
      </div>
    );
  }
}

MarketerForm.propTypes = {
  basePath: PropTypes.string,
  children: PropTypes.node,
  defaultValue: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  handleSubmit: PropTypes.func, // passed by redux-form
  invalid: PropTypes.bool,
  record: PropTypes.object,
  resource: PropTypes.string,
  redirect: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  save: PropTypes.func, // the handler defined in the parent, which triggers the REST submission
  submitOnEnter: PropTypes.bool,
  toolbar: PropTypes.element,
  validate: PropTypes.func,
  showNotification: PropTypes.func,
};

MarketerForm.defaultProps = {
  submitOnEnter: false,
  toolbar: <Toolbar />,
};

const selector = formValueSelector("record-form");

const enhance = compose(
  connect(
    (state, props) => {
      const instagramId = selector(state, "social.instagram.id");
      const facebookId = selector(state, "social.facebook.id");
      const twitterId = selector(state, "social.twitter.id");
      const youtubeId = selector(state, "social.youtube.id");
      const oldValue = getDefaultValues(state, props);
      if (oldValue.social) {
        if (typeof oldValue.social.instagram === "string") {
          const value = oldValue.social.instagram;
          let { social } = oldValue;
          social["instagram"] = {
            id: value,
          };
        }
        if (typeof oldValue.social.facebook === "string") {
          const value = oldValue.social.facebook;
          let { social } = oldValue;
          social["facebook"] = {
            id: value,
          };
        }
        if (typeof oldValue.social.twitter === "string") {
          const value = oldValue.social.twitter;
          let { social } = oldValue;
          social["twitter"] = {
            id: value,
          };
        }
        if (typeof oldValue.social.youtube === "string") {
          const value = oldValue.social.youtube;
          let { social } = oldValue;
          social["youtube"] = {
            id: value,
          };
        }
      } else {
        oldValue["social"] = props.defaultValue.social;
      }

      return {
        initialValues: oldValue,
        instagramId,
        facebookId,
        twitterId,
        youtubeId,
      };
    },
    {
      showNotification: showNotificationAction,
      updateField: (k, v) => change("record-form", k, v),
    }
  ),
  reduxForm({
    form: "record-form",
    enableReinitialize: true,
  })
);

export default enhance(MarketerForm);



// WEBPACK FOOTER //
// ./src/marketers/MarketerForm.js